import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PropTypes from 'prop-types';

function MonthYearPicker({ value, onChange, label, helperText, views, openTo, sx }) {
  return (
    <DatePicker
      variant="inline"
      openTo={openTo}
      views={views}
      label={label}
      helperText={helperText}
      value={value}
      onChange={onChange}
      autoOk
      slotProps={{
        textField: {
          variant: 'standard',
          InputLabelProps: { shrink: true },
        },
      }}
      dayOfWeekFormatter={(dayAsString) => {
        return dayAsString;
      }}
      sx={sx}
    />
  );
}

MonthYearPicker.defaultProps = {
  label: 'Mês e Ano',
  views: ['year', 'month'],
  openTo: 'month',
};
MonthYearPicker.propTypes = {
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  views: PropTypes.array,
  openTo: PropTypes.string,
};
export default MonthYearPicker;
